import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/reevesdotnl/reevesdotnl/src/templates/pdf-view.tsx";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`540 Ma to the present day`}</h2>
    <p><img parentName="p" {...{
        "src": "/reevesdotnl/db1f3555c481e819f468ae829f1426da/feb04-2.gif",
        "alt": "Animation - may take a few seconds to load"
      }}></img></p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../animations"
        }}>{`Select another animation`}</a></li>
    </ul>
    <p>{`The animation above shows the whole-world plate tectonic model that was used with the CPSL 'Atlas' software as at 2004.  The plate rotation model was called 'feb04' and it is displayed above in a Mollweide projection centred at 20 deg S, 25 deg E so as to show re-assembled Gondwana (circled in red) with minimal distortion. As far as possible, Alan Smith took plate rotations from poles published in the literature.  Present day coastlines define pale green continental areas in the animation. The animation goes from 550 Ma to the present day, i.e. covers the whole of the Phanerozoic.`}</p>
    <p>{`The work presented on this website has concentrated only on the refinement of the rotation parameters for the various fragments of Gondwana since about 300 Ma.  The animation above gives an idea of the complexity across the whole earth for a period of time almost twice as far into the past as this.  Nevertheless, Gondwana remained intact as it transited the south pole, 500 to 300 Ma, and with the northern continents joining and leaving it as Pangea formed and broke up.`}</p>
    <p><em parentName="p">{`Updated: 2025 September 19`}</em></p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../animations"
        }}>{`Select another animation`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../../gondwana"
        }}>{`Return to Gondwana main page`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      